import { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ResourceForm from "../../components/manage-resources/resource-form";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

function ManageResourceFormPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const initialData = location.state?.resource || null;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (payload) => {
    const token = localStorage.getItem("accessToken");
    if (!token) { navigate("/"); return; }
    setIsSubmitting(true);
    try {
      const url = isEdit
        ? `${BASE_URL}${API_ENDPOINTS.NONPROFIT_RESOURCES}/${id}`
        : `${BASE_URL}${API_ENDPOINTS.NONPROFIT_RESOURCES}`;
      const res = await fetch(url, {
        method: isEdit ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const result = await res.json().catch(() => null);
      if (!res.ok) throw new Error(result?.message || "Failed to save resource.");
      toast.success(isEdit ? "Resource updated!" : "Resource created!");
      navigate("/dashboard/manage-resources", { state: { refresh: true } });
    } catch (err) {
      toast.error(err.message || "Failed to save resource.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ResourceForm
      initialData={initialData}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      title={isEdit ? "Edit Resource" : "Add New Resource"}
    />
  );
}

export default ManageResourceFormPage;
